import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import React from "react";
import { DefaultToastOptions } from "react-hot-toast";
import Colors from "src/general/constants/colors";

const toastStyle: DefaultToastOptions = {
	duration: 5000,
	success: {
		style: {
			background: Colors.GREEN,
			color: "#FFFFFF",
			borderRadius: "4px",
			fontFamily: "Inter",
			fontSize: "16px",
			fontWeight: 500,
			lineHeight: "24px",
			letterSpacing: "0.15000000596046448px",
			textAlign: "left",
		},
		// icon: (
		// 	<CheckCircleOutlineIcon
		// 		sx={{ margin: "0 8px" }}
		// 		fontSize={"small"}
		// 	/>
		// ),
	},
	error: {
		style: {
			// background: Colors.RED,
			// color: "#FFFFFF",
			// borderRadius: "4px",
			// fontFamily: "Inter",
			// fontSize: "16px",
			// fontWeight: 500,
			// lineHeight: "24px",
			// letterSpacing: "0.15000000596046448px",
			// textAlign: "left",
		},
		icon: (
			<BlockOutlinedIcon
				sx={{ margin: "0 8px" }}
				fontSize={"small"}
			/>
		),
	},
};

export default toastStyle;
